import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { SV_URL } from '../../@core/utils/utils';

@Injectable({ providedIn: 'root' })
export class CoringaProvider {

  public id: string;

  constructor(public http: HttpClient) {}

  saveCoringa(data, cli, valor, status, tipo, user, alt, cod) {
    const url: string = SV_URL + '/postCoringa';

    const postParams = {
      data, cli, valor, status, tipo, user, alt, cod,
    };

    this.http.post(url, postParams)
    .subscribe(res => {
      console.log('Enviado Com Sucesso');
      }, error => {
      console.log(error);
    });
  }

  putCoringa(id, data, cli, valor, tipo, user, alt, cod) {
    const url: string = SV_URL + '/putCoringa';

    const postParams = {
      id: id,
      data: data,
      cli: cli ,
      valor: valor,
      tipo: tipo,
      user: user,
      alt: alt,
      cod: cod,
    };

    this.http.put(url, postParams)
    .subscribe(res => {
      console.log('Enviado Com Sucesso');
      }, error => {
      console.log(error);
    });
  }

  putCoringaStatus(id, cupom, status) {
    return new Promise<void>(resolve => {
      const url: string = SV_URL + '/putCoringaStatus';

      const postParams = {
        id: id,
        cupom: cupom,
        status: status,
      };

      this.http.put(url, postParams)
      .subscribe(res => {
        console.log('Enviado Com Sucesso');
        resolve();
        }, error => {
        console.log(error);
        resolve();
      });
    });

  }

  putCoringaAutorizado(id, user, data, status) {
    const url: string = SV_URL + '/putCoringaAutorizado';

    const postParams = {
      id: id,
      user: user,
      data: data,
      status: status,
    };

    this.http.put(url, postParams)
    .subscribe(res => {
      console.log('Enviado Com Sucesso');
      }, error => {
      console.log(error);
    });
  }

}
